import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useParams } from "react-router";

interface OrgStatsData {
  speciesCount: number;
  recordCount: number;
}

export function OrgStatsComponent({ orgId }: { orgId: string }) {
  const {
    data,
    isLoading,
    isError,
  } = useQuery<OrgStatsData>({
    queryKey: ["org", orgId, "stats"],
    queryFn: async () => {
      if (!orgId) throw new Error("Missing orgId");
      const res = await fetch(`/api/org/${orgId}/stats`);
      if (!res.ok) throw new Error("Failed to fetch org stats");
      return res.json();
    },
    enabled: !!orgId,
  });

  if (isLoading) {
    return (
      <div className="w-full mb-4">
        <div className="flex gap-8">
          <div className="flex flex-col items-center">
            <Skeleton className="h-8 w-8 mb-2" />
            <span className="text-muted-foreground">Species</span>
          </div>
          <div className="flex flex-col items-center">
            <Skeleton className="h-8 w-8 mb-2" />
            <span className="text-muted-foreground">Records</span>
          </div>
        </div>
      </div>
    );
  }
  if (isError || !data) {
    return (
      <div>
        <span className="text-destructive">Failed to load stats</span>
      </div>
    );
  }
  return (
    <div className="flex justify-around  items-center border rounded-full p-2 md:p-4" >
      <div className="flex flex-col items-center">
        <a href={`/app/org/${orgId}/species`} className="text-xl md:text-3xl font-bold">
          {data.speciesCount}
        </a>
        <span className="text-muted-foreground">Species</span>
      </div>
      <div className="flex flex-col items-center">
        <a href={`/app/org/${orgId}/records`} className="text-xl md:text-3xl font-bold">
          {data.recordCount}
        </a>
        <span className="text-muted-foreground">Records</span>
      </div>
    </div>
  );
}
